'use strict';
/* jshint ignore:start */

var wishlist = {

		removeFromWishlistEvent: function (e, pid, price) {
			var wlid;
			if ($('input[name=wishListId]').length > 0) {
				wlid = $('input[name=wishListId]').val();
			}
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				wishlist_id: wlid,
				wishlist_remove: 'wishlist item removed',
				event: 'removeFromWishlist'
			};
			$.extend(obj, getWishListProductData(pid, price));
			dataLayer.push(obj);
		},

		viewWishlistEvent: function () {
			var wlid;
			if ($('input[name=wlID]').length > 0) {
				wlid = $('input[name=wlID]').val();
			} else if ($('input[name=wishListId]').length > 0) {
				wlid = $('input[name=wishListId]').val();
			}
			var obj = {};
			obj.button_ID = ''
			obj.wishlist_id = wlid;
			obj.event = 'viewWishlist';
			$.extend(obj, getWishListProducts());
			dataLayer.push(obj);
		},

		/* Recipe specific events */
		removeRecipeEvent: function (e, pid) {
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				event: 'removeRecipe'
			};
			$.extend(obj, getRecipeProductData(pid));
			dataLayer.push(obj);
		}
};

/**
 * @param event
 * @description Takes data which is available on a page
 */
function getWishListProductData(pid, price) {
	if ($('input[name=' + pid + ']').length > 0) {
		var product = JSON.parse($('input[name=' + pid + ']').val());
		// object to be pushed
		var obj = {};
		obj["product_ID"] = product.product_ID;
		obj["product_brand"] = product.product_brand;
		obj["product_category"] = product.product_category;
		obj["product_hierarchy"] = product.product_hierarchy;
		obj["product_name"] = product.product_name;
		obj["product_SKU"] = product.product_SKU;
		obj["product_variant"] = product.product_variant;
		return obj;
	}
}

function getUrlParams(url) {
	var params = {};
	url.substring(1).replace(/[?&]+([^=&]+)=([^&]*)/gi,
			function (str, key, value) {
				params[key] = value;
			});
	return params;
}

/**
 * Returns an object which contains product data
 * that is mainly identical for all GTM events that are triggered on PDP.
 * Product data is taken either from the html or from hidden input field on PDP
 *
 * @returns Object
 */
function getRecipeProductData(pid) {
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth() + 1; //January is 0!
	var yyyy = today.getFullYear();
	if ($('input[name=' + pid + ']').length > 0) {
		var productObj = JSON.parse($('input[name=' + pid + ']').val());
		// object to be pushed
		var obj = {
			'product_brand': productObj.productBrand,
			'product_category': productObj.productCategory,
			'product_hierarchy': productObj.productHierarchy,
			'product_ID': productObj.productID,
			'product_image': $('.primary-image') ? $('.primary-image').prop('src') : '',
			'product_name': productObj.productName,
			'product_SKU': productObj.productSKU,
			'recipe_brand': productObj.productBrand,
			'recipe_category': productObj.productCategory,
			'recipe_description': productObj.description,
			'recipe_ID': productObj.productID,
			'recipe_image_url': $('.primary-image') ? $('.primary-image').prop('src') : '',
			'recipe_name': productObj.productName,
			'recipe_price': productObj.price,
			're_date_added': dd + '/' + mm + '/' + yyyy
		};
		return obj;
	}
}

/**
 * @param event
 * @description Takes data which is available on a page
 */
function getWishListProducts() {
	if ($('input[name=wishlistData]').length > 0) {
		var wishlistData = JSON.parse($('input[name=wishlistData]').val());
		var products = wishlistData.product;
		var productArray = [];
		var productObj = [];
		for (var i = 0; i < products.length; i++) {
			// object to be pushed
			var obj = {
				'product_brand': products[i].product_brand,
				'product_category': products[i].product_category,
				'product_hierarchy': products[i].product_hierarchy,
				'product_ID': products[i].product_ID,
				'product_name': products[i].product_name,
				'product_price': products[i].product_price,
				'product_price_old': products[i].product_price_old,
				'product_quantity': products[i].product_quantity,
				'product_SKU': products[i].product_SKU,
				'product_stock_status': products[i].product_stock_status,
				'product_variant': products[i].product_variant,
				'product_vat': products[i].product_vat,
				'product_set_capacity': products[i].product_set_capacity,
				'product_set_name':  products[i].product_set_name,
				'product_set_price': products[i].product_set_price,
				'product_set_size': products[i].product_set_size,
				'product_set_SKU': products[i].product_set_size,
				'product_set_type': products[i].product_set_type,
				'voucher_ID': products[i].voucher_ID,
				'voucher_total': products[i].voucher_total
			};
			productArray.push(obj);
		}
		productObj["product"] = productArray;
		return productObj;
	}
}
module.exports = wishlist;
/* jshint ignore:end */
